export default "__VITE_ASSET__74193260__"